import { DateTime } from 'luxon';
import type { Month } from './types';

export const toMonthKey = (month: Month): string =>
  DateTime.fromObject({ month: month.month, year: month.year })
    .startOf('month')
    .toISODate()!;
